/**
 * To avoid merge conflicts, please add new feature flags to a random location (not the last line).
 */
export enum featureFlags {
  PR_FILTERS_DAYS_ON_STOCK = 'pr_filters_days_on_stock',
  PR_SUSPICIOUS_FLAG = 'pr_suspicious_flag',
  PR_REASONING = 'pr_reasoning',
  PR_PRICE_CHANGES = 'pr_price_changes',
  PR_SPLIT_POWER = 'pr_split_power',
  PR_EDIT = 'pr_edit',
  PR_FILTERS_SELLER_TYPE = 'pr_filters_seller_type',
  PR_PRICE_DYNAMICS = 'pr_price_dynamics',
  PR_FORM_STATISTICS = 'pr_form_statistics',
  PR_MULTI_SERVERS = 'pr_multi_servers',
  PR_EQUIPMENT_V2 = 'pr_equipment_v2',
  PR_RELATIVE_FILTERS = 'pr_relative_filters',
}
/**
 * To avoid merge conflicts, please add new feature flags to a random location (not the last line).
 */
